/**********************************************************************
// @@@ START COPYRIGHT @@@
// AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
// Copyright 2018 - 2019
// Avi Solar Energy Pvt Ltd.
// Protected as an unpublished work.
// The computer program listings, specifications and documentation
// herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
// and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <Card>
    <v-flex d-flex md12>
      <Toolbar>
        <v-flex sm4>
          <span class="mr-4 body-2">Adv String Inverter</span>
        </v-flex>
        <v-flex sm4 text-sm-center>
          <Toggle v-show="view === 'overview'" :modelValue="buttonvalue"
            @toggleValueChange="(val) => buttonvalue = val" :theme="theme">
            <v-btn v-if="isLive" flat value="live">{{ $t('Live') }}</v-btn>
            <v-btn flat value="average">{{ $t('Average') }}</v-btn>
          </Toggle>
        </v-flex>
        <v-flex sm4 text-sm-right>
          <div class="body-1">
            {{ show_date }}
          </div>
        </v-flex>
      </Toolbar>
    </v-flex>
    <v-layout row wrap>
      <v-flex sm9>
        <AdvancedStringInverterTable v-if="!!selectedDate && view === 'overview'" :chips="chips" :plantId="getSelectedPlantId"
          :dataView="buttonvalue" :date="selectedDate" @chipsUpdate="chipsUpdated"
          @availableData="(val) => graphParameters = val" />
        <AdvancedStringInverterGraph v-if="!!selectedDate && view === 'graph'" :plantId="getSelectedPlantId" :chips="chips"
          :date="selectedDate" :param="chipsObj" :graphParameters="graphParameters" />
      </v-flex>
      <v-flex sm3>
        <v-layout column pa-0 ma-0>
          <AdvancedStringInverterChip :chips="chips" @aleterSelectedChannels="aleterSelectedChannels" />
          <v-flex xs12 text-xs-center pa-0 pt-2>
            <Toggle :modelValue="view" @toggleValueChange="viewHandler" :theme="theme">
              <v-btn flat value="graph">
                <span>{{ $t('Graph') }}</span>
                <v-icon>bar_chart</v-icon>
              </v-btn>
              <v-btn flat value="overview">
                <span>{{ $t('Table') }}</span>
                <v-icon>table_chart</v-icon>
              </v-btn>
            </Toggle>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <a href="#" class="float">
      <img src="../assets/info.png" height="20px" width="20px" class="my-float" />
    </a>
    <div class="label-container">
      <div class="label-text">*NC: {{ $t('Not Connected') }}</div>
    </div>
  </Card>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
const momentTz = require('moment-timezone')
import AdvancedStringInverterTable from '@/components/AdvancedStringInverter/AdvancedStringInverterTable.vue'
import AdvancedStringInverterChip from '@/components/AdvancedStringInverter/AdvancedStringInverterCombobox.vue'
import AdvancedStringInverterGraph from '@/components/AdvancedStringInverter/AdvancedStringInverterGraph.vue'
import {
  mixin,
  mapGettersMixin,
  colorMixin
} from '@/util/mixin/index'

import {
  mapGetters,
  mapMutations
} from 'vuex'

export default {
  name: 'advanced-string-inverter',
  mixins: [ mixin, mapGettersMixin, colorMixin ],
  components: {
    AdvancedStringInverterTable,
    AdvancedStringInverterGraph,
    AdvancedStringInverterChip
  },
  props: {
    changesFromFilter: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      chips: [],
      chipsObj: {},
      view: 'overview',
      buttonvalue: 'live',
      interval: null,
      graphParameters: new Set(),
      filter: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        }
      ],
      activeFilter: {}
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlantId', 'getActivePlantTimezone']),
    selectedDate() {
      return this.activeFilter.Date ? this.activeFilter.Date.from : ''
    },
    show_date() {
      return moment(this.selectedDate).format('YYYY/M/D')
    },
    isLive() {
      return this.selectedDate
        ? momentTz().tz(this.getActivePlantTimezone).isSame(this.selectedDate, 'day')
        : true
    }
  },
  mounted() {
    const Obj = {}
    const cloneFilterOption = _.cloneDeep(this.filter);
    cloneFilterOption.forEach(child => {
      if (child.type === 'singleDatePicker') {
        const parameters = ['from', 'to']
        parameters.forEach(key => {
          if (!Obj[child.id]) { Obj[child.id] = {} }
          Obj[child.id][key] = momentTz().tz(this.getActivePlantTimezone).format('YYYY-MM-DD')
        })
      }
    })
    this.activeFilter = Obj;
    this.$emit("filter:config", cloneFilterOption);
    this.$emit('initial:active_filter', Obj)
  },
  methods: {
    ...mapMutations([
      'SET_SHOW_SNACKBAR',
      'SET_SNACKBAR_CONTENT'
    ]),
    aleterSelectedChannels(payload) {
      this.chips = _.cloneDeep(payload)
      let obj = {}
      payload.forEach(el => {
        if (obj[el.split('-ch-')[0]]) {
          obj[el.split('-ch-')[0]].push(el.split('-ch-')[1])
        } else {
          obj[el.split('-ch-')[0]] = [el.split('-ch-')[1]]
        }
      })
      this.chipsObj = obj
    },

    viewHandler(payload) {
      if (payload === 'graph') {
        if (this.chips.length > 0) {
          this.view = 'graph'
        } else {
          this.updateSnackbar({
            icon: 'error',
            message: 'Please select String Inverters in order to check graph'
          })
        }
      } else if (payload === 'overview') {
        this.view = 'overview'
      }
    },

    updateSnackbar(payload) {
      this.SET_SHOW_SNACKBAR(true)
      this.SET_SNACKBAR_CONTENT(payload)
    },
    chipsUpdated(payload) {
      this.chips = _.cloneDeep(payload.chips)
      this.chipsObj = payload.chipsObj
    }
  },
  watch: {
    changesFromFilter: {
      handler(val) {
        this.activeFilter = val;
      },
      deep: true,
    },
    chips() {
      if (this.chips.length === 0) {
        this.view = 'overview'
      }
    }
  }
}
</script>

<style scoped>
.label-container {
  position: fixed;
  bottom: 85px;
  right: 13px;
  display: table;
  visibility: hidden;
}

.label-text {
  color: #fff;
  background: var(--v-primary-darken2);
  display: table-cell;
  vertical-align: middle;
  padding: 10px;
  border-radius: 3px;
}

.float {
  position: fixed;
  width: 40px;
  height: 40px;
  bottom: 40px;
  right: 15px;
  color: #fff;
  border-radius: 50px;
  text-align: center;
  animation: glowing 1500ms infinite;
}

.my-float {
  font-size: 24px;
  margin-top: 8px;
}

a.float + div.label-container {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s, opacity 0.5s ease;
}

a.float:hover + div.label-container {
  visibility: visible;
  opacity: 1;
}

@keyframes glowing {
  0% {
    background-color: var(--v-primary-base);
    box-shadow: 0 0 3px #cbcbcb;
  }

  50% {
    background-color: var(--v-primary-base);
    box-shadow: 0 0 10px grey;
  }

  100% {
    background-color: var(--v-primary-base);
    box-shadow: 0 0 3px #cbcbcb;
  }
}
</style>